<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">产品价格管理</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button v-if="$checkAccessArray(['B', 'C'])"
                            type="success"
                            size="small"
                            class="btns"
                            shape="circle"
                            @click="onBatchUpdate">更新</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import CurrencyInput from '@/components/number-input/currency-input';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { singleImageRender } from '@/libs/tableRowImageRender';
import { PRICE_APPROVAL_NO, PRICE_APPROVAL_YES, priceApprovalFormat } from '@/libs/baseModelFormat';
import { formatDateTimeString } from '@/libs/logic';

import { getApprovedProductList } from '@/api/modules/product-management/productApprove-management';
import { updateProductPrice } from '@/api/modules/product-management/productPrice-management';

export default {
    name: 'productPrice-list',
    components: {
        StandPaginationTable,
        SearchCard,
        CurrencyInput
    },
    data() {
        return {
            innerSpin: false,
            PRICE_APPROVAL_NO,
            PRICE_APPROVAL_YES,
            mainTable: {
                tableColumns: [
                    { title: '大类', key: 'mainCategoryName', width: 80, align: 'center' },
                    { title: '小类', key: 'subCategoryName', width: 80, align: 'center' },
                    { title: '品牌', key: 'brandName', width: 80, align: 'center' },
                    { title: '编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '名称', key: 'productName', width: 120, align: 'center' },
                    { title: '单位', key: 'unitName', width: 80, align: 'center' },
                    { title: '销售期限', key: 'productSalesPeriod', width: 80, align: 'center' },
                    { title: '成品图', align: 'center', width: 80, render: (h, params) => singleImageRender(h, params.row.productFinishImageFile) },
                    { title: '最近预售调价', align: 'center', width: 130, render: (h, params) => h('div', {}, params.row.productPreSalePriceUpdateAt ? formatDateTimeString(params.row.productPreSalePriceUpdateAt) : '') },
                    {
                        title: '预售定价',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div', [
                                h(CurrencyInput, {
                                    props: {
                                        value: params.row.productPreSalePrice,
                                        precision: 4
                                    },
                                    style: {
                                        width: '80px'
                                    },
                                    on: {
                                        change: value => {
                                            this.mainTable.tableData[params.index].productPreSalePrice = value;
                                            const productUuid = params.row.productUuid;
                                            const query = this.priceChangeList.find(p => p.productUuid === productUuid);
                                            if (query) {
                                                query.newProductPreSalePrice = value;
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: '预售定价2',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div', [
                                h(CurrencyInput, {
                                    props: {
                                        value: params.row.productPreSalePrice2,
                                        precision: 4
                                    },
                                    style: {
                                        width: '80px'
                                    },
                                    on: {
                                        change: value => {
                                            this.mainTable.tableData[params.index].productPreSalePrice2 = value;
                                            const productUuid = params.row.productUuid;
                                            const query = this.priceChangeList.find(p => p.productUuid === productUuid);
                                            if (query) {
                                                query.newProductPreSalePrice2 = value;
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: '预售定价3',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div', [
                                h(CurrencyInput, {
                                    props: {
                                        value: params.row.productPreSalePrice3,
                                        precision: 4
                                    },
                                    style: {
                                        width: '80px'
                                    },
                                    on: {
                                        change: value => {
                                            this.mainTable.tableData[params.index].productPreSalePrice3 = value;
                                            const productUuid = params.row.productUuid;
                                            const query = this.priceChangeList.find(p => p.productUuid === productUuid);
                                            if (query) {
                                                query.newProductPreSalePrice3 = value;
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: '预售定价4',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            return h('div', [
                                h(CurrencyInput, {
                                    props: {
                                        value: params.row.productPreSalePrice4,
                                        precision: 4
                                    },
                                    style: {
                                        width: '80px'
                                    },
                                    on: {
                                        change: value => {
                                            this.mainTable.tableData[params.index].productPreSalePrice4 = value;
                                            const productUuid = params.row.productUuid;
                                            const query = this.priceChangeList.find(p => p.productUuid === productUuid);
                                            if (query) {
                                                query.newProductPreSalePrice4 = value;
                                            }
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        visibility: this.$checkAccessArray(['B', 'C']) ? 'visible' : 'hidden'
                                    },
                                    on: {
                                        click: () => {
                                            this.updateProductPrice(params.row);
                                        }
                                    }
                                }, '更新')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '大类', type: 'Input', value: '', name: 'mainCategoryName', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '编号', type: 'Input', value: '', name: 'productCode', sql: 'like' },
                    { label: '名称', type: 'Input', value: '', name: 'productName', sql: 'like' }
                ]
            },
            priceChangeList: []
        };
    },
    computed: {
        personName() {
            return this.$store.state.user.personName;
        },
        personType() {
            return this.$store.state.user.personType;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        priceApprovalFormat,
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.filters.conditions.push({
			    name: 'products.isShow',
			    type: 'eq',
			    value: '1'
            });
            getApprovedProductList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);

                    // 记录当页的商品价格原始信息
                    this.priceChangeList = this.mainTable.tableData.map(row => {
                        return {
                            productUuid: row.productUuid,
                            productTag: `${row.productName}（${row.productCode}）`,
                            oldProductPreSalePriceStatus: row.productPreSalePriceStatus,
                            newProductPreSalePriceStatus: row.productPreSalePriceStatus,
                            oldProductPreSalePrice: row.productPreSalePrice,
                            newProductPreSalePrice: row.productPreSalePrice,
                            oldProductPreSalePrice2: row.productPreSalePrice2,
                            newProductPreSalePrice2: row.productPreSalePrice2,
                            oldProductPreSalePrice3: row.productPreSalePrice3,
                            newProductPreSalePrice3: row.productPreSalePrice3,
                            oldProductPreSalePrice4: row.productPreSalePrice4,
                            newProductPreSalePrice4: row.productPreSalePrice4
                        };
                    });
                }

                this.mainTable.tableLoading = false;
            });
        },
        updateProductPrice(productRow) {
            const data = {
                productUuid: productRow.productUuid,
                productTag: `${productRow.productName}（${productRow.productCode}）`,
                productCurSalePriceStatus: productRow.productCurSalePriceStatus,
                productCurSalePrice: productRow.productCurSalePrice,
                productPreSalePriceStatus: productRow.productPreSalePriceStatus,
                productPreSalePrice: productRow.productPreSalePrice,
                productPreSalePrice2: productRow.productPreSalePrice2,
                productPreSalePrice3: productRow.productPreSalePrice3,
                productPreSalePrice4: productRow.productPreSalePrice4
            };

            const submitData = {
                productPrices: [data]
            };
            this.innerSpin = true;
            updateProductPrice(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '更新成功',
                        content: '',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onBatchUpdate() {
            const query = this.priceChangeList.filter(p => {
                return p.oldProductPreSalePriceStatus !== p.newProductPreSalePriceStatus
                    || p.oldProductPreSalePrice !== p.newProductPreSalePrice
                    || p.oldProductPreSalePrice2 !== p.newProductPreSalePrice2
                    || p.oldProductPreSalePrice3 !== p.newProductPreSalePrice3
                    || p.oldProductPreSalePrice4 !== p.newProductPreSalePrice4;
            });
            if (query.length === 0) {
                this.$Modal.warning({ title: '无需更新', content: '暂无变更内容' });
                return;
            }

            const submitData = {
                productPrices: query.map(p => {
                    return {
                        productUuid: p.productUuid,
                        productTag: p.productTag,
                        productPreSalePriceStatus: p.newProductPreSalePriceStatus,
                        productPreSalePrice: p.newProductPreSalePrice,
                        productPreSalePrice2: p.newProductPreSalePrice2,
                        productPreSalePrice3: p.newProductPreSalePrice3,
                        productPreSalePrice4: p.newProductPreSalePrice4
                    };
                })
            };

            this.innerSpin = true;
            updateProductPrice(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '更新成功',
                        content: '',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        }
    }
};
</script>l

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .action {
        float: right;
    }
}
</style>
